import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkupPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5 5.49994L18.3284 8.32837M3.00024 20.9997L3.0477 20.6675C3.21561 19.4922 3.29956 18.9045 3.49053 18.3558C3.65999 17.8689 3.89149 17.4059 4.1793 16.9783C4.50366 16.4963 4.92343 16.0765 5.76299 15.237L17.411 3.58896C18.192 2.80791 19.4584 2.80791 20.2394 3.58896C21.0205 4.37001 21.0205 5.63634 20.2394 6.41739L8.37768 18.2791C7.61604 19.0408 7.23522 19.4216 6.80144 19.7244C6.41642 19.9932 6.00117 20.2159 5.56422 20.3879C5.07195 20.5817 4.544 20.6882 3.48817 20.9012L3.00024 20.9997Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMarkupPencil;
